<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="inspectionTemplate.pkId > 0 ? '编辑' : '新建'"
      class="employee-edit"
      width="1200px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="inspectionTemplate"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-row>
        <el-col :span="4">
          <el-form-item label="编号">
            <el-input v-model="inspectionTemplate.templateNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="名称" prop="templateName">
            <el-input v-model="inspectionTemplate.templateName" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item label="类型">
            <el-radio-group v-model="inspectionTemplate.templateType" :disabled="inspectionTemplate.pkId > 0">
              <el-radio :label="10">外购入库</el-radio>
              <el-radio :label="20">成品入库</el-radio>
              <el-radio :label="30">生产过程</el-radio>
              <el-radio :label="40">成品出库</el-radio>
              <el-radio :label="50">巡检</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-form-item label="检验标准" prop="sampleStandard">
            <el-select v-model="inspectionTemplate.sampleStandard">
              <el-option value="GBT2828"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="检验等级" prop="checkLevel">
            <el-select v-model="inspectionTemplate.checkLevel">
              <el-option value="Ⅰ"/>
              <el-option value="Ⅱ"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="AQL" prop="aql">
            <el-input v-model="inspectionTemplate.aql" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="物料类型" prop="materialTypeName">
            <el-input v-model="inspectionTemplate.materialTypeName" placeholder="请选择物料类型" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectMaterialType.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="描述">
          <el-input v-model="inspectionTemplate.note" type="textarea" placeholder="请输入"/>
        </el-form-item>
      </el-row>
      <el-row>
        <el-divider/>
        <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectInspection.open()"> 添加</el-button>
        <el-table
            height="400px"
            class="childMetrialTable"
            :data="inspectionTemplate.details"
            border>
          <!--          <el-table-column type="index" label="#" align="center" width="55"/>-->
          <!--          <el-table-column prop="inspectionItemNo" align="left" label="检验编号"/>-->
          <el-table-column prop="inspectionItemName" align="left" label="名称"/>
          <el-table-column prop="inspectionCategory" align="left" label="类别"/>
          <el-table-column prop="inspectionStandard" align="left" label="检验标准"/>
          <el-table-column prop="standardValue" align="center" label="标准值">
            <template slot-scope="scope">
              <el-input v-model="scope.row.standardValue" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="maxValue" align="center" label="最大值">
            <template slot-scope="scope">
              <el-input v-model="scope.row.maxValue" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="minValue" align="center" label="最小值">
            <template slot-scope="scope">
              <el-input v-model="scope.row.minValue" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="unit" align="center" label="单位">
            <template slot-scope="scope">
              <el-input v-model="scope.row.unit" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="note" align="center" label="备注">
            <template slot-scope="scope">
              <el-input v-model="scope.row.note" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="scope">
              <el-button type="danger" @click="deleteRow(scope.$index)"> 删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submit">确定</el-button>
    </span>
    <inspection-select ref="selectInspection" @select="selectInspection"/>
    <material-type-selector ref="selectMaterialType" @select="selectMaterialType"/>
  </el-dialog>
</template>

<script>
  import constants from "../../../util/constants";
  import InspectionSelect from "@/views/information/Inspection/InspectionSelect";
  import MaterialTypeSelector from "@/views/information/MaterialTypeName/MaterialTypeSelector";

  export default {
    name: "InspectionTemplateEdit",
    components: {InspectionSelect, MaterialTypeSelector},
    data() {
      return {
        constants,
        positionList: [],
        dialogVisible: false,
        submitLoading: false,
        inspectionTemplate: {
          pkId: 0,
          templateNo: "",
          templateName: "",
          templateType: 10,
          sampleStandard: "GBT2828",
          checkLevel: "Ⅱ",
          aql: "性能类0.4 其它类1.0",
          note: "",
          materialTypeName: "",
          materialTypeId: "",
          materialTypeNo: "",
          details: [],
        },
        ruleValidate: {
          templateName: {required: true, message: "请输入名称", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.inspectionTemplate.pkId = row.pkId;
          this.getData();
        } else {
          this.getNode();
        }
      },

      // 根据id查询信息
      getData() {
        this.$http.get("basic", `inspectionTemplates/${this.inspectionTemplate.pkId}`).then((resp) => {
          if (resp.success) {
            this.inspectionTemplate = resp.data;
            console.log(resp.data);
          }
        });
      },
      // 获取编号
      getNode() {
        this.$http.get("basic", "inspectionTemplates/getNo").then((resp) => {
          if (resp.success) {
            this.inspectionTemplate.templateNo = resp.data;
          }
        });
      },
      // 选择
      selectInspection(row) {
        var isExist = false;
        this.inspectionTemplate.details.forEach((item) => {
          if (item.inspectionItemNo == row.no) {
            isExist = true;
          }
        });
        if (isExist) {
          this.$message.error("重复添加");
          return;
        }
        const item = {
          inspectionItemID: row.pkId,
          inspectionItemNo: row.no,
          inspectionItemName: row.name,
          inspectionCategory: row.inspectionCategory,
          inspectionStandard: row.inspectionStandard,
          standardValue: row.standardValue,
          maxValue: row.maxValue,
          minValue: row.minValue,
          unit: row.unit,
          note: row.note,
        };
        this.inspectionTemplate.details.push(item);
      },
      // 删除选中的行
      deleteRow(index) {
        this.inspectionTemplate.details.splice(index, 1);
      },
      // 物料类型选择
      selectMaterialType(row) {
        this.inspectionTemplate.materialTypeName = row.name;
        this.inspectionTemplate.materialTypeId = row.id;
      },
      // 提交
      submit() {
        if (this.inspectionTemplate.pkId > 0) {
          this.handleSubmitUpdData();
        } else {
          this.handleSubmitSave();
        }
      },

      // 编辑
      handleSubmitUpdData() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .put("basic", "inspectionTemplates", this.inspectionTemplate)
                .then((resp) => {
                  if (resp.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },

      // 新建
      handleSubmitSave() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .post("basic", "inspectionTemplates", this.inspectionTemplate)
                .then((resp) => {
                  if (resp.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },
    },
  };
</script>
